import React, { useState } from 'react';
import { IconButton, Tooltip, Badge } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import BulkPrintDialog, { BulkPrintProcedureItem } from './BulkPrintDialog';

interface BulkPrintViewProps {
  items: BulkPrintProcedureItem[];
  sourcePage?: string;
}

/**
 * Compact Print Documents button - icon-only with badge showing selection count.
 * Tooltip shows instructions when no items selected.
 */
const BulkPrintView = ({ items, sourcePage }: BulkPrintViewProps) => {
  const [open, setOpen] = useState(false);
  const hasItems = items.length > 0;

  return (
    <>
      <Tooltip title={hasItems ? `Print ${items.length} selected` : 'Select procedures to print'}>
        <span>
          <IconButton size="small" color="primary" onClick={() => setOpen(true)} disabled={!hasItems}>
            <Badge badgeContent={hasItems ? items.length : 0} color="primary" invisible={!hasItems}>
              <PrintIcon />
            </Badge>
          </IconButton>
        </span>
      </Tooltip>
      <BulkPrintDialog open={open} onClose={() => setOpen(false)} items={items} sourcePage={sourcePage} />
    </>
  );
};

export default BulkPrintView;
